@if (hero(); as hero) {
  <wl-hero-wrapper [hero]="hero">
    <div class="hero" [class.hero__multi-column]="isMultiColumnLayout()">
      <div class="hero__content">
        <div class="hero__content-primary">
          <wl-hero-heading [hero]="hero" />

          @if (showParagraph() && paragraph(); as paragraph) {
            <div class="hero__paragraph" *scText="paragraph"></div>
          }
          @if (showRichText() && richText(); as richText) {
            <div class="hero__rich-text" *wlGenericRichText="richText"></div>
          }

          @if (showButtonGroup()) {
            <wl-hero-button-group class="hero__button-group" [hero]="hero" />
          }
        </div>
        @if (showBottomImage() && bottomImage(); as bottomImage) {
          <div class="hero__content-secondary">
            <img class="hero__image" *scImage="bottomImage" />
          </div>
        }
      </div>
      @if (isMultiColumnLayout()) {
        <div class="hero__sidebar">
          @if (hasWidget()) {
            <wl-hero-widget [hero]="hero" />
          } @else {
            @if (mainImage(); as mainImage) {
              <img class="hero__image" *scImage="mainImage" />
            }
          }
        </div>
      }
    </div>
  </wl-hero-wrapper>
}
